<template>
  <b-modal id="modal-notification" :hide-footer="true"  :hide-header="true"   :centered="true" size="xl">
    <img class="close" src="@/assets/img/close_red.png" @click="$bvModal.hide('modal-notification')">
    <div class="d-flex justify-content-end pt-4">
      <b-button variant="outline-primary" class="btn-outline"><b-icon icon="pencil-square"></b-icon>Editar</b-button>
      <b-button class="ml-2" variant="primary">Aceptar</b-button>
      <b-button class="ml-2" variant="danger">Rechazar</b-button>
    </div>
    <div v-if="showLoadingFirst" class="container-loading">
      <b-spinner :label="$t('reusables.loading')" ></b-spinner>
    </div>
    <template v-else>
      <FullCalendar class="demo-app-calendar" :options="calendarOptions"  ref="fullCalendar">
        <template v-slot:eventContent="arg">
          <div class="fc-event-main-frame" @click="getDataClass(arg.event)">
            <div class="fc-event-time">{{ arg.timeText }}</div>
            <div class="fc-event-title-container">{{ arg.event.title }}</div>
          </div>
        </template>
      </FullCalendar>
    </template>
  </b-modal>
</template>
<script>
import '@fullcalendar/core/vdom'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from "@fullcalendar/timegrid";
import { getCalendarHeaderFormat, getCalendarTitle, getFormatDateComplete, getCalendarEventTimeFormat,getCalendarHeaderToolbar,getHoursByTimeZoneName } from '@/assets/js/util.js';

export default {
  data(){
        return{
            lang:localStorage.getItem('lang'),
            showLoadingFirst:false,
            formatDay : "DD",
            calendarOptions: {
                plugins: [
                    dayGridPlugin,
                    timeGridPlugin,
                    interactionPlugin, // needed for dateClick
                ],
                events: [],
                firstDay : 1,
                //eventColor: "#4285f4",
                eventOverlap: false,
                themeSystem: "bootstrap",
                nowIndicator: true,
                headerToolbar:  {
                    left: "",
                    center:  'title',
                    right:'',
                },
                buttonText:{
                    today: this.$t('reusables.today'), 
                },
                titleFormat: function(date) {
                    return getCalendarTitle(date.date, this.lang);
                },
                height: "auto",
                allDaySlot: false,
                viewDidMount: (view) => {
                  let GMT = getHoursByTimeZoneName(this.$moment, this.$store.state.user.timeZoneName);
                  view.el.querySelector('.fc-timegrid-axis-frame').innerHTML = GMT;
                },
                initialView: "timeGridWeek",
                dayHeaderContent: (args) => {
                    return getCalendarHeaderFormat(this.$moment, args.date, this.lang,this.formatDay);
                },
                eventTimeFormat: getCalendarEventTimeFormat(),
                initialEvents: [], //INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
                editable: false,
                scrollTimeReset:false,
                selectable: false,
                selectMirror: true,
                dayMaxEvents: true,
                weekends: true,
                eventResizableFromStart: false,
               
            },
        }
    },
    components: {
      FullCalendar
    },
}
</script>